import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import MainSection from '@/components/MainSection';
import ProductDetails from '../components/product/productDetails/ProductDetails';
import { products } from '@/core/global-data/products.data';
import MoneyFinancial from '@/assets/svg/products/Moneyfinancial';

const FINANCIAL_PRODUCT_ID = 8;

export default function FinancialManagementPage() {
    const { t } = useTranslation();
    const product = products.find((p) => p.id === FINANCIAL_PRODUCT_ID) ?? products[FINANCIAL_PRODUCT_ID - 1];

    return (
        <>
            <Helmet>
                <title>{t('financialManagementPage.metaTitle')}</title>
                <meta name="description" content={t('financialManagementPage.mainDesc')} />
                <link rel="canonical" href="/financial-management" />
            </Helmet>

            <div className="relative mb-[100px] w-full overflow-hidden">
                <MainSection
                    title={t('financialManagementPage.mainTitle')}
                    description={t('financialManagementPage.mainDesc')}
                    icon={
                        <MoneyFinancial className="h-[180px] w-[180px] object-contain sm:h-[200px] sm:w-[210px]" />
                    }
                />
            </div>

            <div className="relative mb-12 w-full overflow-hidden mainContainer lg:mb-[100px]">
                <ProductDetails product={product} />
            </div>
        </>
    );
}
